var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{attrs:{"id":"app"}},[(!_vm.ocultarMenu)?_c('Menu'):_vm._e(),_c('div',{class:{ 'ocultar-menu': _vm.ocultarMenu },attrs:{"id":"contenido"}},[_c('router-view')],1)],1),_c('AlertaSnackBar',{attrs:{"alerta-snack-bar":{
      color: 'informativo',
      contenido: 'Nueva versión disponible',
    },"btn-accion":{ icono: 'sync', texto: 'Clic para actualizar'},"mostrar-snack-bar":_vm.notificacionNuevaVersion},on:{"btn-accion":_vm.actualizarApp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }